import React, { useState, useEffect, Suspense, useMemo } from 'react';
import { settings } from 'carbon-components';
import classNames from 'classnames';
import AssistendRemediationTab from 'components/TaskDetails/AssistendRemediationTab';
import Tabs from 'carbon-components-react/lib/components/Tabs';
import Tab from 'carbon-components-react/lib/components/Tab';
import AlertsTable from '../ManageAutomationPage/Alerts/AlertsTable';
import { Pagination } from 'carbon-components-react';
import * as Constants from '../../requests/URLConstants'
import callPostApi from "../../requests/PostRequests";
import { WarningFilled32, TreeView16, TreeViewAlt16 } from '@carbon/icons-react'
import i18n from "../../i18n";
import * as IncidentDetailsConstants from './IncidentDetailsPage/IncidentDetailsConstants'
import * as workspaces from '../../config/WorkspaceConstants'
import * as configConst from "../../config/Constants";

var config = require('../../config/appConfig.json');
require("../IncidentDetails/Tabs/_tab-component.scss");




const { prefix } = settings;

const CustomLabel = ({ text }) => text;


const TabContentRenderedOnlyWhenSelected = ({
    selected,
    children,
    className,
    ...other
}) =>
    !selected ? (
        <div {...other} className={`${prefix}--visually-hidden`} />
    ) : (
        <div
            {...other}
            className={classNames(className, `${prefix}--tab-content`)}
            selected={selected}>
            {children}
        </div>
    );


export const IncidentDetailsTabComponent = props => {
    const [RCAselected, setRCAselected] = useState(false);
    const [impactselected, setImpactselected] = useState(true);
    const [remediationselected, setRemediationselected] = useState(false);
    const [notesselected, setNotesselected] = useState(false);
    const [resolutionselected, setResolutionselected] = useState(false);
    const [assistanceselected, setAssistanceselected] = useState(false);
    const [predictedAlertRows, setpredictedAlertRows] = useState([]);
    const [alertTotalItems, setalertTotalItems] = useState(0);
    const [alertFirstRowIndex, setalertFirstRowIndex] = useState(0);
    const [alertCurrentPageSize, setalertCurrentPageSize] = useState(10);
    const [predictedAlertFirstRowIndex, setpredictedAlertFirstRowIndex] = useState(0);
    const [predictedAlertCurrentPageSize, setpredictedAlertCurrentPageSize] = useState(10);
    const [alertRows, setRows] = useState([{}]);
    const [itemDetailsSelected, setItemDetailsSelected] = useState(false);

    let paginatedAlertRows = alertRows.slice(alertFirstRowIndex,
        alertFirstRowIndex + alertCurrentPageSize);
    let paginatedPredictedAlertRows = predictedAlertRows.slice(predictedAlertFirstRowIndex,
        predictedAlertFirstRowIndex + predictedAlertCurrentPageSize);

    const ErrorMessage = i18n.t('IncidentDetails.ErrorMessage');
    const PreviousPage = i18n.t('IncidentDetails.Previouspage');
    const nextPage = i18n.t('IncidentDetails.nextPage');
    const Itemspage = i18n.t('IncidentDetails.Itemspage');
    const ImpactAnalysisTab = i18n.t('IncidentDetails.ImpactAnalysisTab');
    const RootcauseAnalysis = i18n.t('IncidentDetails.RootcauseAnalysis');
    const Resolution = i18n.t('IncidentDetails.Resolution');
    const Notes = i18n.t('IncidentDetails.Notes');
    const Remediation = i18n.t('IncidentDetails.Remediation');
    const Category = i18n.t('IncidentDetails.Category');
    const Subcategory = i18n.t('IncidentDetails.SubCategory');
    const Assistance = i18n.t('IncidentDetails.Assistance');
    const NoContent = i18n.t('IncidentDetails.NoContent');

    const headers = [
        {
            header: i18n.t('IncidentDetails.Log'),
            key: 'Log',
        },

        {
            header: i18n.t('IncidentDetails.StageName'),
            key: 'StageName',
        },
        {
            header: i18n.t('IncidentDetails.StageType'),
            key: 'StageType',
        },
        {
            header: i18n.t('IncidentDetails.Process'),
            key: 'ProcessName',
        },
        {
            header: i18n.t('IncidentDetails.Page'),
            key: 'PAGENAME',
        },
        {
            header: i18n.t('IncidentDetails.Object'),
            key: 'OBJECTNAME',
        },
        {
            header: i18n.t('IncidentDetails.Action'),
            key: 'ACTIONNAME',
        },
        {
            header: i18n.t('IncidentDetails.Result'),
            key: 'Result',
        },
        {
            header: i18n.t('IncidentDetails.Start'),
            key: 'StartDateTime',
        },
        {
            header: i18n.t('IncidentDetails.End'),
            key: 'EndDateTime',
        },
    ];
    const getRCA = () => {
        setRCAselected(!RCAselected);
        setImpactselected(false);
        setAssistanceselected(false);
        setNotesselected(false);
        setResolutionselected(false);
        setRemediationselected(false);
        setItemDetailsSelected(false);
    }
    const getImpact = () => {
        setImpactselected(!impactselected);
        setAssistanceselected(false);
        setNotesselected(false);
        setResolutionselected(false);
        setRemediationselected(false);
        setRCAselected(false);
        setItemDetailsSelected(false);

    }
    const getAssistance = () => {
        setAssistanceselected(!assistanceselected);
        setNotesselected(false);
        setResolutionselected(false);
        setRemediationselected(false);
        setRCAselected(false);
        setImpactselected(false);
        setItemDetailsSelected(false);

    }
    const getNotes = () => {
        setNotesselected(!notesselected);
        setResolutionselected(false);
        setRemediationselected(false);
        setRCAselected(false);
        setImpactselected(false);
        setAssistanceselected(false);
        setItemDetailsSelected(false);

    }
    const getResolution = () => {
        setResolutionselected(true);
        setRemediationselected(false);
        setRCAselected(false);
        setImpactselected(false);
        setAssistanceselected(false);
        setNotesselected(false);
        setItemDetailsSelected(false);

    }
    const getRemediation = () => {
        setRemediationselected(!remediationselected);
        setRCAselected(false);
        setImpactselected(false);
        setAssistanceselected(false);
        setNotesselected(false);
        setResolutionselected(false);
        setItemDetailsSelected(false);

    }

    const getItemDetails = () => {
        setItemDetailsSelected(!itemDetailsSelected);
        setRCAselected(false);
        setImpactselected(false);
        setAssistanceselected(false);
        setNotesselected(false);
        setResolutionselected(false);
        setResolutionselected(false);

    }


    const RCAComponentSAP = React.lazy(() => import("../IncidentDetails/Tabs/RootCauseAnalysis/RootCauseAnalysisSapTest"));
    const RCAComponent = React.lazy(() => import("../IncidentDetails/Tabs/RootCauseAnalysis/RootCauseAnalysis"));
    const NotesTab = React.lazy(() => import("../IncidentDetails/Tabs/Notes/NotesTab"));
    const ResolutionTab = React.lazy(() => import("../IncidentDetails/Tabs/Resolution/ResolutionTab"));
    const ImpactAnalysis = React.lazy(() => import("./Tabs/ImpactAnalysis/ImpactAnalysisSAP_Elk"));
    const ImpactAnalysisAutomation = React.lazy(() => import("../IncidentDetails/Tabs/ImpactAnalysis/ImpactAnalysis"));
    const ImpactAnalysisSAP = React.lazy(() => import("../IncidentDetails/Tabs/ImpactAnalysis/ImpactAnalysisSAP"));
    const ImpactAnalysisAutomationDF = React.lazy(() => import("../IncidentDetails/Tabs/ImpactAnalysis/ImpactAnalysisDF"));
    const RemediationTab = React.lazy(() => import("../IncidentDetails/Tabs/Remediation/RemediationTab"));
    const AssistanceTab = React.lazy(() => import("../IncidentDetails/Tabs/Assistance/AssistanceTab"));
    const ItemDetailsTab = React.lazy(() => import("../IncidentDetails/Tabs/ItemDetails/ItemDetailTab"));

    const renderImpactTabs = useMemo(() => {
        return (impactselected &&
            props.workspace === workspaces.automation_ops ? props.alertType === "Dependency failure" ?
            <div>
                <ImpactAnalysisAutomationDF incidentId={props.incidentId} incidentArray={props.incidentArray} alertType={props.alertType} />
            </div> :
            <div>
                {console.log("test auto")} <ImpactAnalysisAutomation incidentId={props.incidentId} incidentArray={props.incidentArray} alertType={props.alertType} />
            </div> :
            (props.incidentArray.u_technology !== 'SAP' || (props.aiopsInfo !== 'WATSON_AIOPS')) ?
                <div>
                    {console.log("test impact")}<ImpactAnalysis incidentId={props.incidentId} incidentArray={props.incidentArray} alertType={props.alertType} />
                </div>
                :
                <ImpactAnalysisSAP selectedEntity={props.selectedEntity} impactselected={impactselected} />
        )
    }, [impactselected, props.workspace, props.incidentId, props.incidentArray, props.alertType, props.incidentArray.u_technology, props.aiopsInfo, props.selectedEntity])

    useEffect(() => {
        const bodyJSON = {
            "automataBusnKey": props.incidentArray.u_process_id,
            "jobId": props.jobId,
            "appHostMachineName": props.incidentArray.u_app_host_machine_name
        }


        callPostApi(Constants.AUTOMATAEXCEPTIONLOGSURL, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                if (resp) {
                    let rowsArray_list = [];
                    resp.forEach(element => {
                        let taskobject = {};
                        taskobject.StageType = element.STAGETYPE ? element.STAGETYPE : 'N.A';
                        taskobject.StageName = element.STAGENAME ? element.STAGENAME : 'N.A';
                        taskobject.StartDateTime = element.STARTDATETIME ? element.STARTDATETIME : 'N.A';
                        taskobject.EndDateTime = element.ENDDATETIME ? element.ENDDATETIME : 'N.A';
                        taskobject.ProcessName = element.ProcessName ? element.ProcessName : 'N.A';
                        taskobject.PageName = element.PAGENAME ? element.PAGENAME : 'N.A';
                        taskobject.Object = element.OBJECTNAME ? element.OBJECTNAME : 'N.A';
                        taskobject.Action = element.ACTIONNAME ? element.ACTIONNAME : 'N.A';
                        taskobject.Result = element.Result ? element.Result : 'N.A';


                        taskobject.id = element.PAGENAME + element.ACTIONNAME;
                        rowsArray_list.push(taskobject);
                    });
                    setRows(rowsArray_list);
                    setalertTotalItems(rowsArray_list.length)
                }

            }).catch((error) => {
                console.error('Error:', error);
            });

    }, []);

    return (
        <div
            className={"container-tabs-story-wrapper--light tabs-size tab-full-width"
            }>
            <Tabs type="container" >
                <Tab id="impactTab" onClick={getImpact} label={ImpactAnalysisTab}>
                    <div className="some-content">
                        <Suspense fallback={<div>{IncidentDetailsConstants.loading}</div>}>
                            <section>
                                {renderImpactTabs}
                            </section>
                        </Suspense>
                    </div>
                </Tab>
                <Tab id="RCATab" onClick={getRCA} label={RootcauseAnalysis}>
                    <div className="rca-graph">
                        <div className="rca-error-container">
                            <div className="error-panel">
                                <div className="error-info">
                                    <div className="left-icon-error">
                                        <div style={{ paddingRight: "10px" }} >
                                            <WarningFilled32 />
                                        </div>
                                        <div>
                                            <div className="title carbon-display-Regular-20">
                                                {ErrorMessage}
                                            </div>
                                            <div className="description">
                                                {props.incidentArray && props.incidentArray.description ? props.incidentArray.description : "No content to display"}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="categorySubcategory">
                                        <div>
                                            <div className="icon">
                                                <TreeView16 />
                                            </div>
                                            <div>
                                                <div className="category carbon-display-Regular-14">{props.incidentArray.category ? props.incidentArray.category.label : ''} </div>
                                                <div className="sub-category carbon-display-Regular-9">{Category}</div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="icon">
                                                <TreeViewAlt16 />
                                            </div>
                                            <div>
                                                <div className="category carbon-display-Regular-14">{props.incidentArray.subcategory ? props.incidentArray.subcategory.label : '' || 'NA'} </div>
                                                <div className="sub-category carbon-display-Regular-9">{Subcategory}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Suspense fallback={<div>{IncidentDetailsConstants.loading}</div>}>
                            <section>
                                {RCAselected && props.incidentArray.u_technology !== 'SAP' ? <RCAComponent incidentArray={props.incidentArray} incidentArrayLastExceptions={props.incidentArrayLastExceptions} isShow={props.isShow} workspace={props.workspace} /> : ''}
                                {RCAselected && props.incidentArray.u_technology === 'SAP' ? <RCAComponentSAP incidentArray={props.incidentArray} incidentArrayLastExceptions={props.incidentArrayLastExceptions} isShow={props.isShow} workspace={props.workspace} /> : ''}
                                {props.incidentArray.u_technology !== 'SAP' ?
                                    <div>
                                        <AlertsTable
                                            headers={headers}
                                            rows={paginatedAlertRows}
                                            fullRows={paginatedPredictedAlertRows}
                                            RCAFlag={true}
                                            showFilters={false}

                                        />
                                        <Pagination
                                            totalItems={alertTotalItems}
                                            backwardText={PreviousPage}
                                            forwardText={nextPage}
                                            pageSize={alertCurrentPageSize}
                                            pageSizes={[5, 10, 15, 25]}
                                            itemsPerPageText={Itemspage}
                                            onChange={({ page, pageSize }) => {
                                                if (pageSize !== alertCurrentPageSize) {
                                                    setalertCurrentPageSize(pageSize);
                                                }
                                                let newFirstRowIndex = pageSize * (page - 1);
                                                setalertFirstRowIndex(newFirstRowIndex)
                                            }}
                                        />
                                    </div>
                                    : null
                                }
                            </section>
                        </Suspense>
                    </div>
                </Tab>
                <Tab id="assistanceTab" onClick={getAssistance} label={Assistance}>
                    <div className="some-content">
                        {props.incidentArray.u_technology !== 'SAP' ?
                            <Suspense fallback={<div>{IncidentDetailsConstants.loading}</div>}>
                                <section>
                                    {assistanceselected ? <AssistanceTab sysId={props.sysId} incidentId={props.incidentId} process={props.incidentArray.u_process_name} client={props.client} /> : ''}
                                </section>
                            </Suspense>
                            : <Suspense fallback={<div>{IncidentDetailsConstants.loading}</div>}>
                                <section>
                                    {assistanceselected ? <AssistanceTab sysId={props.sysId} incidentId={props.incidentId} process={props.incidentArray.short_description} client={props.client} /> : ''}
                                </section>
                            </Suspense>}
                    </div>
                </Tab>

                <Tab
                    id="remediationTab"
                    label={Remediation}
                    title="Remediation"
                    onClick={getRemediation}
                    renderContent={TabContentRenderedOnlyWhenSelected}>
                    <div className="some-content">
                        {props.incidentArray.u_technology !== 'SAP'
                            ?
                            ((props.incidentArray.category && props.incidentArray.category.label) != "Alert" &&
                                ((props.incidentArray.subcategory && props.incidentArray.subcategory.label != "Dependency failure") || (props.incidentArray.subcategory && props.incidentArray.subcategory.label != "Long pending") || (props.incidentArray.subcategory && props.incidentArray.subcategory.label != "Long running"))) &&
                            <Suspense fallback={<div>{IncidentDetailsConstants.loading}</div>}>
                                <section>
                                    {remediationselected ? <RemediationTab remediationFlag={props.updateremediationFlag} sysId={props.sysId} incidentId={props.incidentId} workspace={props.workspace} client={props.client} numberId={props.incidentArray.number} disableIncidentUpdate={props.disableIncidentUpdate} incidentArray={props.incidentArray} /> : ''}
                                </section>
                            </Suspense>
                            :
                            <Suspense fallback={<div>{IncidentDetailsConstants.loading}</div>}>
                                <section>
                                    {remediationselected ? <AssistendRemediationTab incidentId={props.incidentArray.number} /> : ''}
                                </section>
                            </Suspense>
                        }
                    </div>
                </Tab>

                <Tab className="notes"
                    id="notesTab"
                    onClick={getNotes}
                    label={<CustomLabel text={Notes} />}>
                    <div>
                        <Suspense fallback={<div>{IncidentDetailsConstants.loading}</div>}>
                            <section>
                                {notesselected ? <NotesTab sysId={props.sysId} incidentId={props.incidentId} workspace={props.workspace} client={props.client} franchise={props.franchise} assignmentGroup={(props.incidentArray.assignment_group ? props.incidentArray.assignment_group.label : "")} disableIncidentUpdate={props.disableIncidentUpdate} ></NotesTab> : ''}
                            </section>
                        </Suspense>

                    </div>
                </Tab>
                <Tab className="resolution"
                    id="resolutionTab"
                    onClick={getResolution}
                    label={<CustomLabel text={Resolution} />}>
                    <div>
                        <Suspense fallback={<div>{IncidentDetailsConstants.loading}</div>}>
                            <section>
                                {resolutionselected ? <ResolutionTab sysId={props.sysId} incidentId={props.incidentId} disableIncidentUpdate={props.disableIncidentUpdate} workspace={props.workspace} client={props.client} franchise={props.franchise} getIncidentDetails={props.getIncidentDetails} incidentArray={props.incidentArray}></ResolutionTab> : ''}
                            </section>
                        </Suspense>

                    </div>
                </Tab>
                {(props.Queue || props.IncidentQueue) ?
                    <Tab
                        id="itemDetaiTab"
                        label="Item Details"
                        title="Item Details"
                        onClick={getItemDetails}
                        renderContent={TabContentRenderedOnlyWhenSelected}>
                        <div className="some-content">
                            <Suspense fallback={<div>{IncidentDetailsConstants.loading}</div>}>
                                <section>
                                    {itemDetailsSelected ? <ItemDetailsTab sysId={props.sysId} incidentId={props.incidentId} workspace={props.workspace} client={props.client} numberId={props.incidentArray.number} disableIncidentUpdate={props.disableIncidentUpdate} incidentArray={props.incidentArray} IncidentQueue={props.IncidentQueue} Queue={props.Queue} AppHostMachineName={props.AppHostMachineName}/> : ''}
                                </section>
                            </Suspense>
                        </div>
                    </Tab> : null}
            </Tabs>
        </div>
    );
}